import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface LogoProps {
    variant?: 'color' | 'white'
    className?: string
}

const Logo: FC<LogoProps> = ({ variant = 'color', className }): ReactNode => {
    if (variant === 'white') {
        return (
            <Image
                src='/images/skillkafe-logo-white.png'
                alt="Skillkafe, bridge the skill gap"
                width={1050}
                height={480}
                sizes='200px'
                className={cn('h-20 w-auto', className)}
            />
        )
    }

    // The square brand mark has generous padding, so it is cropped to the wordmark
    return (
        <span className={cn('relative block h-11 w-16 overflow-hidden sm:h-12 sm:w-[70px]', className)}>
            <Image
                src='/images/skillkafe-logo.png'
                alt='Skillkafe'
                fill
                sizes='70px'
                loading='eager'
                className='object-cover'
            />
        </span>
    )
}

export default Logo
